/**
 * Scroll the PLP/search product grid to the top of the viewport, sitting
 * just below the sticky header (and collection toolbar when present).
 *
 * Uses instant window.scrollTo — iOS Safari often cancels `behavior: 'smooth'`
 * when the grid re-renders after a page change, leaving the user at the
 * bottom of the new page.
 */

const GRID_SELECTOR = '[data-plp-scroll-target]'
const TOOLBAR_SELECTOR = '[data-plp-toolbar]'
const HEADER_SELECTOR = '#shopify-section-site-header'

function getStickyOffset() {
  const toolbar = document.querySelector(TOOLBAR_SELECTOR)
  if (toolbar) {
    const stickyTop = parseFloat(getComputedStyle(toolbar).top)
    return (Number.isFinite(stickyTop) ? stickyTop : 0) + toolbar.offsetHeight
  }

  const header = document.querySelector(HEADER_SELECTOR)
  return header?.offsetHeight ?? 0
}

function applyScroll() {
  const target = document.querySelector(GRID_SELECTOR)
  const top = target
    ? Math.max(0, target.getBoundingClientRect().top + window.scrollY - getStickyOffset())
    : 0
  window.scrollTo(0, top)
}

export function scrollPlpGridIntoView() {
  applyScroll()
  requestAnimationFrame(() => {
    applyScroll()
    requestAnimationFrame(applyScroll)
  })
}
